import { render } from "./NotifyReset.vue?vue&type=template&id=b27ed8b2"
import script from "./NotifyReset.vue?vue&type=script&lang=js"
export * from "./NotifyReset.vue?vue&type=script&lang=js"

import "./NotifyReset.vue?vue&type=style&index=0&id=b27ed8b2&lang=sass"

import exportComponent from "/home/runner/work/wiki.zems.pro/wiki.zems.pro/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__